/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default ($) => {
  return css`
    code {
      font-size: ${$.codeFontSize};
      color: ${$.codeColor};
      word-wrap: break-word;
      
      a > & {
        color: inherit;
      }
    }

    kbd {
      padding: ${$.kbdPaddingY} ${$.kbdPaddingX};
      font-size: ${$.kbdFontSize};
      color: ${$.kbdColor};
      background-color: ${$.kbdBg};
      border-radius: ${$.borderRadiusSm};
      box-shadow: ${$.kbdBoxShadow};

      kbd {
        padding: 0;
        font-size: 100%;
        font-weight: ${$.nestedKbdFontWeight};
        box-shadow: none;
      }
    }

    pre {
      display: block;
      font-size: ${$.codeFontSize};
      color: ${$.preColor};

      code {
        font-size: inherit;
        color: inherit;
        word-break: normal;
      }
    }

    .pre-scrollable {
      max-height: ${$.preScrollableMaxHeight};
      overflow-y: scroll;
    }
  `;
}
